

















import Vue from "vue";
import Component from "vue-class-component";

import { namespace } from "vuex-class";

const databaseModule = namespace("database");

@Component({
  components: {}
})
export default class writeoffDay extends Vue {
  @databaseModule.State("writeoffActivityList") list!: any;
  tabActive: Number = 0; /* 默认tab第一个 */

  mounted() {
    this.getData();
  }
  getData() {
    this.$nextTick(() => {
      this.getDayOrMonthCount();
    });
  }
  async getDayOrMonthCount() {
    // 统计指定主体最近7天或者最近6个月的核销数。
    let postData = {
      businessEntityId: this.$global.tenantId,
      type: this.tabActive
    };
    const { error, success } = await this.$store.dispatch(
      "database/getDayOrMonthCount",
      postData
    );
    let res = success && success.data;
    console.log(success);
    console.log(res);
    if (success.code == 200) {
      let xData = [],
        seriesData = [];
      if (res && res.length > 0) {
        let dateStr = this.tabActive == 0 ? "dateDay" : "dateMonth";
        xData = res.map((item: any) => item[dateStr]);
        seriesData = res.map((item: any) => item.count);
      }
      this.setEchart(xData, seriesData);
    }
  }
  setEchart(xData = [], seriesData = []) {
    // xData = ['2019.06.01', '2019.06.02', '2019.06.03', '2019.06.04', '2019.06.05', '2019.06.06', '2019.06.07'];
    // seriesData = [10, 52, 200, 334, 390, 330, 220];
    let echartStr = this.tabActive == 0 ? "echart1" : "echart2";
    (this.$refs[echartStr] as any).setOption({
      color: "#0245BF",
      tooltip: {
        trigger: "axis"
      },
      grid: {
        left: 20,
        right: 35,
        bottom: 0,
        top: 40,
        containLabel: true
      },
      xAxis: {
        type: "category",
        data: xData,
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          fontSize: 18
        }
      },
      yAxis: {
        type: "value",
        axisLabel: {
          fontSize: 18
        }
      },
      series: {
        name: "每日核销",
        type: "bar",
        barWidth: 40,
        label: {
          show: true,
          position: "top"
        },
        data: seriesData
      }
    });
  }

  tabChangeHandler(name: string, title: string) {
    // tab切换触发事件
    this.getDayOrMonthCount();
  }
}
